























































































































































































































































import { clientFormComposition } from '@/compositions/clientForm'
import { defineComponent, PropType, ref } from '@vue/composition-api'
import ClientDialog from './Remittance/ClientDialog.vue'
import ClientAutocomplete from './Remittance/ClientAutocomplete.vue'
import PhoneTextField from '@/components/PhoneTextField.vue'
import Autocomplete from '@/components/Autocomplete.vue'
import Combobox from '@/components/Combobox.vue'
import { mask } from 'vue-the-mask'
import { getAccountNumberInfo, getCardInfo } from '@/utils/functions'
import { Client } from '@/api/Agency/agency.interface'
import { ClientRelation } from '~/utils/interfaces/remittance.interface'

export default defineComponent({
  components: {
    ClientDialog,
    ClientAutocomplete,
    PhoneTextField,
    Autocomplete,
    Combobox,
  },
  directives: { mask },
  props: {
    data: {
      type: Object as PropType<{ client_origin: string }>,
      required: true,
    },
    mlc: Boolean,
    mlx: Boolean,
    ust: Boolean,
    client: Object as PropType<Client>,
  },
  setup: props => {
    const clientComposition = clientFormComposition('DESTINY', props)
    const { onNext } = clientComposition

    const request_signature = ref(false)
    const defaultCountry = { country: 'CU', callingCode: '53' }

    const newNext = async () => {
      return await onNext(props.data.client_origin)
    }

    return {
      ...clientComposition,
      onNext: newNext,
      defaultCountry,
      request_signature,
    }
  },
  data() {
    return {
      disableFilter: false,
      idRule: (v: string) => {
        if (!v.length) return true
        if (v.length !== 11) return this.$t('validation.id')
        return true
      },
      relations: Object.values(ClientRelation).map(value => ({
        text: this.$t(`_relation.${value}`),
        value,
      })),
    }
  },
  computed: {
    creditCardImg(): string {
      const card = getCardInfo(this.crud.credit_card)
      return this.getCardImage(card)
    },
    bankImg(): string {
      const bank = getAccountNumberInfo(this.crud.account_number)
      return this.getCardImage(bank)
    },
    cardInfo(): string {
      const card = getCardInfo(this.crud.credit_card)
      return card
    },
    isUstCard(): boolean {
      return ['BANDEC USD Prepago', 'Clásica'].includes(this.cardInfo)
    },
    creditCardInfo(): string {
      if (!this.cardInfo) {
        return ''
      }

      if (this.cardInfo === 'AIS' && this.mlx) return ''

      if (!this.isUstCard && this.ust)
        return ''

      return this.$t('card') + ' ' + this.cardInfo
    },
    accountNumberInfo(): string {
      const card = getAccountNumberInfo(this.crud.account_number)
      if (card) {
        return this.$t('card') + ' ' + card
      }
      return ''
    },
    isSpecialRemittance(): boolean {
      return !!(this.mlx || this.ust)
    },
    creditCardRules(): Function[] {
      if (this.ust) {
        return [this.rules.required, this.creditCard, this.cardRule, this.ustCardRule]
      }

      if ((this.mlx || this.mlc) && !this.crud.account_number) {
        return [this.rules.required, this.creditCard, this.cardRule, this.notUstCardRule]
      }

      return [this.creditCard, this.notUstCardRule]
    },
    accountNumberRules(): Function[] {
      if ((this.mlc || this.mlx) && !this.crud.credit_card) {
        return [this.rules.required, this.creditCard, this.accountNumberRule]
      }
      return [this.creditCard]
    },
  },
  methods: {
    getCardImage(bank: string) {
      switch (bank) {
        case 'Clásica':
          return '/img/cards/clasica.jpeg'
        case 'BANDEC USD Prepago':
          return '/img/cards/bandec_ust.jpeg'
        case 'BANDEC':
          return '/img/cards/bandec.jpeg'
        case 'BPA':
          return '/img/cards/bpa.jpeg'
        case 'METROPOLITANO':
          return '/img/cards/metro.jpeg'

        default:
          return ''
      }
    },
    accountNumberRule() {
      if (!this.accountNumberInfo)
        return this.$t('validation.bank_not_recognized')
      return true
    },
    creditCard(value: string) {
      if (!value) return true
      const parts = value.split(' ')
      if (parts.length < 4) return this.$t('validation.incorrect_format')
      if (parts.find(part => part.length < 4))
        return this.$t('validation.incorrect_format')
      return true
    },
    cardRule() {
      if (!this.creditCardInfo) return this.$t('validation.bank_not_recognized')
      return true
    },
    ustCardRule() {
      if (!this.isUstCard) return this.$t('validation.ust_card_not_recognized')
      return true
    },
    notUstCardRule() {
      if (this.isUstCard) return this.$t('validation.ust_card_recognized')
      return true
    },
  },
})
